<template>
    <Dialog v-model:open="open">
        <DialogTrigger as-child>
            <slot />
        </DialogTrigger>
        <DialogContent class="sm:max-w-[425px]">
            <DialogHeader>
                <DialogTitle> {{ $t("domains.add_domain") }}</DialogTitle>
            </DialogHeader>
            <form @submit.prevent="addDomain">
                <div class="gap-4 py-4 grid">
                    <div class="max-w-sm gap-1.5 grid w-full items-center">
                        <Label for="domain">{{ $t("domains.domain") }}</Label>
                        <Input
                            id="domain"
                            v-model="domain"
                            type="text"
                            placeholder="example.com"
                        />
                        <p v-if="error" class="text-sm text-red-600">
                            {{ error }}
                        </p>
                    </div>
                </div>
                <DialogFooter>
                    <ZButton :disabled="loading" class="ml-4" type="submit">
                        <svg
                            v-if="loading"
                            class="-ml-1 size-5 animate-spin text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                class="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                            ></circle>
                            <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                        </svg>
                        {{ $t("domains.add_domain") }}
                    </ZButton>
                </DialogFooter>
            </form>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import ZButton from "../../Atomic/Button.vue";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";

const open = ref(false);
const domain = ref("");
const error = ref<string | null>(null);

const loading = ref(false);

async function addDomain() {
    loading.value = true;
    error.value = null;

    router.post(
        route("app.domains.store"),
        {
            name: domain.value,
        },
        {
            onSuccess: () => {
                open.value = false;
                domain.value = "";
            },
            onError: (errors) => {
                error.value = errors.name ?? null;
            },
            onFinish: () => {
                loading.value = false;
            },
        },
    );
}
</script>
